import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import Userdetail from "./Features/Userdetail";
import Productdetail from "./Features/Productdetail";
import OrderSummary from "./Features/OrderSummary";

const BaseUrl = axiosInstance.defaults.baseURL;
const API_URL = `${BaseUrl}/api/products`;
// const API_URL = "http://localhost:3000/api/products";
const USERS_API_URL = `${BaseUrl}/api/users`;

const Singleproducts = () => {
  const [orderData, setOrderData] = useState({});
  const [products, setProducts] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [formStatus, setFormStatus] = useState("neworder");
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch data from the API
        const orderResponse = await fetch(`${API_URL}/getsingleproduct/${id}`);

        if (orderResponse.ok) {
          const order = await orderResponse.json();
          setOrderData(order);

          const productResponses = await Promise.all(
            order.product.map(async (product) => {
              const productResponse = await fetch(
                `${API_URL}/get-product/${product.productId}`
              );
              return productResponse.json();
            })
          );
          setProducts(productResponses);

          const userResponse = await fetch(
            `${USERS_API_URL}/details/${order.user}`
          );

          if (userResponse.ok) {
            const userData = await userResponse.json();
            setUserDetails(userData);
          } else {
            console.error(
              "Error fetching user details:",
              userResponse.statusText
            );
          }
        } else {
          console.error("Error fetching order:", orderResponse.statusText);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    // Call the fetchData function inside useEffect
    fetchData();
  }, [id]);

  const handleButtonClick = async () => {
    try {
      // Make a PUT request to update the form status
      const response = await fetch(
        `${API_URL}/update-status/${orderData._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            status: "pending", // Change this to the new status
          }),
        }
      );

      if (response.ok) {
        // Update the form status in the component state if the request is successful
        setFormStatus("pending");
      } else {
        // Handle error if the request is not successful
        console.error("Failed to update form status");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (loading) {
    return <p>Loading...</p>; // You can replace this with a loading spinner or component
  }
  return (
    <>
      <div className="mt-20">
        <ul className="flex bg-amber-500 p-2 rounded-md">
          <li className="p-2 text-white hover:bg-amber-600 transition">
            <Link to={"/admin/home"} className="text-white">
              Home
            </Link>
          </li>
          <li className="p-2 text-white hover:bg-amber-600 transition">
            <Link to={"/admin/orders"} className="text-white">
              Orders
            </Link>
          </li>
        </ul>
      </div>

      <div className="  mr-14 w-full ">
        <div className="  p-2">
          <div
            key={orderData._id}
            className="bg-white border w-full rounded-lg  overflow-hidden p-4 shadow-md md:flex md:ml-16 md:w-full md:justify-evenly"
          >
            {/* User details goes here  */}
            <Userdetail userDetails={userDetails} />

            {/* Additional details */}
            <Productdetail products={products} orderData={orderData} />

            {/* Order Details Goes here  */}
            <OrderSummary
              orderData={orderData}
              handleButtonClick={handleButtonClick}
              formStatus={formStatus}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Singleproducts;
